import React from "react";
import {Box, Heading, Text, Stack} from "@unibuddy/patron";
import {IconInformationCircle} from "../../../../icons";

type ErrorMessageProps = {
    title: string;
    message: string;
};

export function ErrorMessage({title, message}: Readonly<ErrorMessageProps>) {
    return (
        <Box
            bgColor="red100"
            color="red800"
            padding="medium"
            borderRadius="xxsmall"
            margin="small"
            marginBottom="none"
        >
            <Stack space="small">
                <Box display="flex" alignItems="center" gap="xsmall">
                    <IconInformationCircle width="24px" height="24px" />
                    <Heading size="xxsmall" level="3" color="red800">
                        {title}
                    </Heading>
                </Box>
                <Text size="small" color="red800">
                    {message}
                </Text>
            </Stack>
        </Box>
    );
}
